import React, { useState, useEffect, Fragment } from 'react';
import {
    Card,
    CardBody,
    CardImg,
    ButtonGroup,
    Button,
    Row,
    Modal,
    ModalHeader,
    InputGroupAddon,
    InputGroupText,
    Input,
    ModalBody,
    InputGroup,
    CustomInput
} from 'reactstrap';
import { ChromePicker } from 'react-color'
import {
    Separator,
    Colxx,
} from '../../../../../../components/common/CustomBootstrap';

import {
    colorBlockStlye,
    editingStlyeWithoutBackGround,
    SelectStyle,
    AvatarSizeStyle,
    InputStlye,
    setBackGroundColor,
} from '../../style/DigitalAssistantStyle';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import avatars from '../../data/avatarData';
//import Avatar from './Avatar';
import ImageGallery from '../../../propinfo/gallery/index';
import { getGroupID } from '../../../../../../helpers/AxiosAPI';
import { string } from 'prop-types';
import FontsList from '../FontsList';

export default function CalendarIntegration({
    isVoucher = false,
    botSettings,
    saveIntegration,
    integrationId,
    locale
}) {
    console.log('botsetting', botSettings)

    const [edit, setEdit] = useState(true);
    let [setting, setSetting] = useState(botSettings);
    const [error, setError] = useState(true);
    const [layout, setLayout] = useState('Rounded');

    let [iseditMode, setEditMode] = useState({
        'buttonColor': false,
        'buttonTextColor': false,
        'selectedButtonColor': false,
        'selectedButtonTextColor': false,
    });

    useEffect(() => {
        if (botSettings) {
            setSetting(botSettings);
            setLayout(botSettings?.calendarSetting?.layout);
        }
    }, [botSettings]);

    const handleWidgetLayout = (e) => {
        const newLayout = e.target.value;

        setLayout(newLayout);
        console.log('newlayout', newLayout, layout);
        setSetting(prevSetting => ({
            ...prevSetting,
            calendarSetting: { ...prevSetting.calendarSetting, layout: newLayout },
        }));
    };

    const SetClose = () => {
        setEditMode({
            'buttonColor': false,
            'buttonTextColor': false,
            'selectedButtonColor': false,
            'selectedButtonTextColor': false,
        });
    };

    const CloseColorBox = (event) => {
        if (
            (iseditMode.buttonColor === true ||
                iseditMode.buttonTextColor === true ||
                iseditMode.selectedButtonColor === true ||
                iseditMode.selectedButtonTextColor === true)
        ) {
            SetClose();
        }
    };

    const handleSave = () => {
        setEdit(!edit);
        saveIntegration({ botSetting: { ...setting, calendarSetting: setting.calendarSetting } });
    };
    console.log('botcolor', botSettings.calendarSetting)
    return (
        <Fragment>
            {setting ? (
                <Card>
                    <CardBody name="bodyClick" onClick={(e) => { CloseColorBox(e); }}>
                        <div className="text-center">
                            <h6>  <IntlMessages id='integration.booking_calendar' /></h6>
                            <Separator className="mb-3" />


                        </div>

                        <div className="mb-2 mt-4 text-center " style={{ margin: '0px 40px' }}>
                            <div className=" text-center  mb-1">
                                {setting.calendarSetting !== undefined && (
                                    <div className=''>

                                        <b>Layout</b>

                                        <br />

                                        <select
                                            name="Widget Layout"
                                            type='select'
                                            style={SelectStyle}
                                            value={layout}
                                            onChange={(e) => handleWidgetLayout(e)}
                                        >
                                            <option value='Rounded'> Rounded </option>
                                            <option value='Square Edges'>Square Edges </option>
                                        </select>
                                        <p><span style={{ color: '#A9A9A9' }}>Default: Rounded</span></p>
                                    </div>
                                )}
                            </div>


                        </div>

                        <div className="text-left mt-4">
                            {/* <div className="mb-1 text-center"><b>Colour Settings</b></div> */}
                            <div style={{ padding: '0 5%' }}>
                                <Row>

                                    <Colxx xxs="12">
                                        <div >
                                            <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                                <div className='col-md-8 text-left' ><span className=''>Fil color for the start and end date </span></div>
                                                <div className='col-md-4'>
                                                    <InputGroup>
                                                        <Input
                                                            className=""
                                                            type="text"
                                                            onChange={(e) => {
                                                                let newCalendarSetting = { ...setting.calendarSetting };
                                                                newCalendarSetting.buttonColor = e.target.value;
                                                                console.log('newCalendersetting', newCalendarSetting);
                                                                setSetting({ ...setting, calendarSetting: newCalendarSetting });
                                                            }}
                                                            value={setting.calendarSetting.buttonColor}
                                                        />
                                                        <InputGroupAddon addonType="append">
                                                            <InputGroupText onClick={() => {
                                                                setEditMode({ ...iseditMode, buttonColor: !iseditMode.buttonColor });
                                                            }} className="color-square" style={setBackGroundColor(setting.calendarSetting.buttonColor)}></InputGroupText>
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                </div>
                                            </div>
                                        </div>
                                        {iseditMode.buttonColor && <div className='parent-div'>
                                            <div className='cover' onClick={(e) => { e.stopPropagation(); }}>

                                                <ChromePicker
                                                    disableAlpha={true}
                                                    className='ml-2'
                                                    style={{ width: '240px' }}
                                                    color={setting.calendarSetting.buttonColor}
                                                    onChangeComplete={(e) => {
                                                        if (edit) {
                                                            let newCalendarSetting = { ...setting.calendarSetting };
                                                            newCalendarSetting.buttonColor = e.hex;
                                                            setSetting({ ...setting, calendarSetting: newCalendarSetting });
                                                            setEditMode({ ...iseditMode, buttonColor: false });
                                                        } else setError(true);
                                                    }}
                                                />
                                            </div>
                                        </div>}
                                    </Colxx>

                                    <Colxx xxs="12">
                                        <div >
                                            <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                                <div className='col-md-8 text-left' ><span className=''>
                                                    Text color for the start and end date </span></div>
                                                <div className='col-md-4'>
                                                    <InputGroup>
                                                        <Input
                                                            className=""
                                                            type="text"
                                                            onChange={(e) => {
                                                                let newCalendarSetting = { ...setting.calendarSetting };
                                                                newCalendarSetting.buttonTextColor = e.target.value;
                                                                setSetting({ ...setting, calendarSetting: newCalendarSetting });
                                                            }}
                                                            value={setting.calendarSetting.buttonTextColor}
                                                        />
                                                        <InputGroupAddon addonType="append">
                                                            <InputGroupText onClick={() => {
                                                                setEditMode({ ...iseditMode, buttonTextColor: !iseditMode.buttonTextColor });
                                                            }} className="color-square" style={setBackGroundColor(setting.calendarSetting.buttonTextColor)}></InputGroupText>
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                </div>
                                            </div>
                                        </div>
                                        {iseditMode.buttonTextColor && <div className='parent-div'>
                                            <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                                                <ChromePicker
                                                    disableAlpha={true}
                                                    className='ml-2'
                                                    style={{ width: '240px' }}
                                                    color={setting.calendarSetting.buttonTextColor}
                                                    onChangeComplete={(e) => {
                                                        if (edit) {
                                                            let newCalendarSetting = { ...setting.calendarSetting };
                                                            newCalendarSetting.buttonTextColor = e.hex;
                                                            setSetting({ ...setting, calendarSetting: newCalendarSetting });
                                                            setEditMode({ ...iseditMode, buttonTextColor: false });
                                                        } else setError(true);
                                                    }}
                                                />

                                            </div>
                                        </div>}
                                    </Colxx>
                                    <Colxx xxs="12">
                                        <div>
                                            <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                                <div className='col-md-8 text-left' style={{ marginTop: '0.30rem' }}>
                                                    <span className=''>Fill color for the dates within the selected range </span>
                                                </div>
                                                <div className='col-md-4 align-items-center'>
                                                    <InputGroup>
                                                        <Input
                                                            className=""
                                                            type="text"
                                                            onChange={(e) => {
                                                                let newCalendarSetting = { ...setting.calendarSetting };
                                                                newCalendarSetting.selectedButtonColor = e.target.value;
                                                                setSetting({ ...setting, calendarSetting: newCalendarSetting });
                                                            }}
                                                            value={setting.calendarSetting.selectedButtonColor}
                                                        />
                                                        <InputGroupAddon addonType="append">
                                                            <InputGroupText onClick={() => {
                                                                setEditMode({ ...iseditMode, selectedButtonColor: !iseditMode.selectedButtonColor });
                                                            }} className="color-square" style={setBackGroundColor(setting.calendarSetting.selectedButtonColor)}></InputGroupText>
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                </div>
                                            </div>
                                        </div>
                                        {iseditMode.selectedButtonColor && <div className='parent-div'>
                                            <div className='cover' onClick={(e) => { e.stopPropagation(); }}>

                                                <ChromePicker
                                                    disableAlpha={true}
                                                    className='ml-2'
                                                    style={{ width: '240px' }}
                                                    color={setting.calendarSetting.selectedButtonColor}
                                                    onChangeComplete={(e) => {
                                                        if (edit) {
                                                            let newCalendarSetting = { ...setting.calendarSetting };
                                                            newCalendarSetting.selectedButtonColor = e.hex;
                                                            setSetting({ ...setting, calendarSetting: newCalendarSetting });
                                                            setEditMode({ ...iseditMode, selectedButtonColor: false });
                                                        } else setError(true);
                                                    }}
                                                />
                                            </div>
                                        </div>}
                                    </Colxx>
                                    <Colxx xxs="12">
                                        <div >
                                            <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                                <div className='col-md-8 text-left' ><span className=''> Text color for the dates within the selected range </span></div>
                                                <div className='col-md-4'>
                                                    <InputGroup>
                                                        <Input
                                                            className=""
                                                            type="text"
                                                            onChange={(e) => {
                                                                let newCalendarSetting = { ...setting.calendarSetting };
                                                                newCalendarSetting.selectedButtonTextColor = e.target.value;
                                                                setSetting({ ...setting, calendarSetting: newCalendarSetting });
                                                            }}
                                                            value={setting.calendarSetting.selectedButtonTextColor}
                                                        />
                                                        <InputGroupAddon addonType="append">
                                                            <InputGroupText onClick={() => {
                                                                setEditMode({ ...iseditMode, selectedButtonTextColor: !iseditMode.selectedButtonTextColor });
                                                            }} className="color-square" style={setBackGroundColor(setting.calendarSetting.selectedButtonTextColor)}></InputGroupText>
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                </div>
                                            </div>
                                        </div>
                                        {iseditMode.selectedButtonTextColor && <div className='parent-div'>
                                            <div className='cover' onClick={(e) => { e.stopPropagation(); }}>

                                                <ChromePicker
                                                    disableAlpha={true}
                                                    className='ml-2'
                                                    style={{ width: '240px' }}
                                                    color={setting.calendarSetting.selectedButtonTextColor}
                                                    onChangeComplete={(e) => {
                                                        if (edit) {
                                                            let newCalendarSetting = { ...setting.calendarSetting };
                                                            newCalendarSetting.selectedButtonTextColor = e.hex;
                                                            setSetting({ ...setting, calendarSetting: newCalendarSetting });
                                                            setEditMode({ ...iseditMode, selectedButtonTextColor: false });
                                                        } else setError(true);
                                                    }}
                                                />
                                            </div>
                                        </div>}
                                    </Colxx>
                                </Row>
                                {/* <div className="my-2 mt-3 text-center"><b>Font Settings</b></div> */}

                            </div>
                            <Separator className="mb-3 mt-4" />
                            <div className='text-center'>
                                <div className="mb-2 " style={{ marginTop: '40px' }}>
                                    <Button color="primary" size="xs" onClick={handleSave}>
                                        Save
                                    </Button>
                                    <Button
                                        size="xs"
                                        color="secondary"
                                        className='ml-2'
                                        onClick={() => {
                                            CloseColorBox();
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </CardBody>
                </Card >
            ) : null
            }

        </Fragment >
    );
}

